import { useI18n } from "@/lib/i18n";
import { useParametres } from "@/hooks/useParametres";
import { useSeo } from "@/hooks/useSeo";
import { truncate } from "@/lib/seo";



const PRINCIPLE_KEYS = [
  { titleKey: "editorial.accuracy.title", bodyKey: "editorial.accuracy.body" },
  { titleKey: "editorial.verification.title", bodyKey: "editorial.verification.body" },
  { titleKey: "editorial.independence.title", bodyKey: "editorial.independence.body" },
  { titleKey: "editorial.neutrality.title", bodyKey: "editorial.neutrality.body" },
  { titleKey: "editorial.sources.title", bodyKey: "editorial.sources.body" },
  { titleKey: "editorial.nohate.title", bodyKey: "editorial.nohate.body" },
  { titleKey: "editorial.nopropaganda.title", bodyKey: "editorial.nopropaganda.body" },
  { titleKey: "editorial.ai.title", bodyKey: "editorial.ai.body" },
  { titleKey: "editorial.correction.title", bodyKey: "editorial.correction.body" },
];

function EditorialPage() {
  const { t } = useI18n();
  const { data: parametres } = useParametres();
  const titre = parametres?.["pages.editorial.titre"];
  const description = parametres?.["pages.editorial.corps"];

  useSeo({
    title: `${titre || t("editorial.heading")} — Ramba News`,
    description: truncate(description || t("editorial.description")),
    path: "/editorial",
  });
  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 py-10 md:py-14">
      <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-verified">{t("nav.editorial")}</div>
      <h1 className="mt-2 font-serif text-3xl md:text-5xl font-semibold tracking-tight">{titre || t("editorial.heading")}</h1>
      <p className="mt-4 text-lg text-muted-foreground leading-relaxed whitespace-pre-wrap">
        {description || t("editorial.description")}
      </p>

      <ol className="mt-10 space-y-6">
        {PRINCIPLE_KEYS.map((p, i) => (
          <li key={p.titleKey} className="grid gap-2 border-l-2 border-verified/40 pl-5">
            <div className="flex items-baseline gap-3">
              <span className="font-mono text-xs text-muted-foreground">0{i + 1}</span>
              <h2 className="text-lg font-semibold tracking-tight">{t(p.titleKey)}</h2>
            </div>
            <p className="text-base text-foreground/85 leading-relaxed">{t(p.bodyKey)}</p>
          </li>
        ))}
      </ol>
    </div>
  );
}

export default EditorialPage;
